import React from 'react';
import UserContext from './UserContext';

const useUserContext = () => React.useContext(UserContext);

export default useUserContext;
